import { render, staticRenderFns } from "./LinkedBankAccountManagement.vue?vue&type=template&id=fcd9b66e"
import script from "./LinkedBankAccountManagement.vue?vue&type=script&lang=ts"
export * from "./LinkedBankAccountManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports